import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormProps } from 'react-hook-form';
import {
  CreateVisitConsultRequestReservationRequest,
  TimeCode,
} from '@remodeling/remodeling-manager';

export type ImgItemType = {
  url: string;
  seq: number;
};

export interface ReserveType
  extends Omit<CreateVisitConsultRequestReservationRequest, 'visitTimeType'> {
  visitTimeType: TimeCode;
}

const InitValues: Partial<ReserveType> = {
  agreement: undefined,
  channel: undefined,
  comment: '',
  images: [],
  itemType: null,
  simpleUserAgent: 'PC_WEB',
  userName: '',
  userTel: '',
  visitDate: '',
  visitShop: undefined,
  visitTimeType: undefined,
};

export const quickConsultFormSchema = yup.object().shape({
  visitDate: yup.string().required('해당 항목은 필수값 입니다.'),
  visitTimeType: yup.string().required('방문 시간을 입력해주세요.'),
  agree: yup.boolean().isTrue('개인정보 수집 및 이용에 관한 동의를 해주세요'),

  userName: yup
    .string()
    .required('해당 항목은 필수값 입니다.')
    .min(1, '최소 1글자 입니다.')
    .max(20, '최대 20글자까지만 입력가능합니다')
    .matches(/^[a-zA-Z가-힣\s]{1,20}$/g, {
      message: '이름을 정확히 입력해 주세요.',
    }),

  userTel: yup
    .string()
    .required('휴대폰번호를 입력해 주세요')
    .min(12, '휴대폰번호를 정확히 입력해 주세요.')
    .max(13),
});

const ReserveFormHook = (option?: UseFormProps<ReserveType>) => {
  return useForm<ReserveType>({
    defaultValues: InitValues,
    resolver: yupResolver(quickConsultFormSchema),
    mode: 'onSubmit',
    ...option,
  });
};

export default ReserveFormHook;
